export const pozaDomemData = {
    order: 8,
    name: 'poza-domem',
    title: 'Poza domem',
    iconSrc: 'pic_poza-domem.svg',
    headlineText:
        'Ekologia zaczyna się od podjęcia decyzji, że nadszedł czas na zmiany i odejście od starych przyzwyczajeń. Podejmij ją i Ty!',
    mainText:
        'Bądźmy konsekwentni – o ekologiczny, przyjazny dla środowiska sposób życia powinniśmy dbać także będąc poza domem. Zobaczmy, co możemy zrobić będąc w restauracji, na spacerze czy w lesie. ',
    mainVideoSrc: '',
    odpadySection: [
        {
            text:
                'Unikaj jednorazowych opakowań z tworzyw sztucznych. W przypadku gdy spożywasz napoje poza domem, używaj kubka termicznego czy szklanej butelki wielokrotnego użytku, a w ulubionej kawiarni poproś o kawę na wynos we własnym kubku (np. termicznym).',
        },
        {
            text:
                'Używaj słomek wielokrotnego użytku – np. słomianych, bambusowych czy metalowych.',
        },
        {
            text: 'W miejscach publicznych zwracaj uwagę na segregację odpadów.',
        },
        {
            text:
                'Będąc poza domem, pomyśl o zapakowaniu do kieszonki plecaka niewielkiego worka na śmieci, dzięki czemu będziesz mógł zbierać napotkane po drodze śmieci.',
        },
    ],
    klimatSection: [
        {
            text:
                'Podczas spaceru w lecie czy wyprawy w góry nie niszcz runa leśnego i nie rozgarniaj ściółki. ',
        },
        {
            text:
                'Nie zbaczaj ze ścieżek i szlaków – często w ten sposób możesz zniszczyć naturalne siedliska zwierząt i roślin.',
        },
        {
            text: 'Biwakuj i parkuj samochód tylko w wyznaczonych miejscach.',
        },
        {
            text:
                'Szerz wiedzę na temat ekologicznego sposobu życia wśród rodziny, znajomych, kolegów z pracy czy innych osób, z którymi masz kontakt.',
        },
        {
            text:
                'Istnieje wiele akcji charytatywnych, których celem jest dbanie o środowisko i wzrost świadomości ekologicznej połączone z pomaganiem potrzebującym. Warto je wspierać!',
        },
        {
            text:
                'Żyj świadomie! Działaj aktywnie na rzecz środowiska, poszerzaj horyzonty, zgłębiaj wiedzę o tym, jak ograniczyć wpływ człowieka na środowisko.',
        },
    ],
    energiaSection: [
        {
            text:
                'Korzystaj ze schodów zamiast z windy. Każda przejażdżka windą to zużyta energia, którą często można zaoszczędzić wybierając schody.',
        },
    ],
    powietrzeSection: [],
    wodaSection: [],
    czyWieszSection: [
        {
            text:
                '...Polak rocznie zużywa średnio 490 jednorazowych reklamówek foliowych, a  Duńczyk lub Fin tylko 4?...',
            more:
                'Produkcja torby foliowej trwa zaledwie 1 sekundę. Jak podaje WWF, używana średnio przez 25 minut rozkłada się od 100 do 400 lat. Do jej produkcji zużywa się gaz, wodę, energię i ropę naftową. Na ropie, która została wykorzystana do wyprodukowania jednej reklamówki, samochód może przejechać 115 metrów.',
        },
        {
            text: '...w Polsce codziennie zużywa się 3 miliony słomek jednorazowych?...',
            more:
                'Rocznie to 1,2 miliarda sztuk. W USA jest to nawet 500 milionów słomek dziennie! Ilość ta równa się 120 autobusom wypełnionych plastikiem.' +
                '<br /><br /><a target="_blank" rel="noopener noreferrer" href="https://www.wwf.pl/aktualnosci/wakacje-w-morzu-plastiku-i-oceanie-toksyn">https://www.wwf.pl/aktualnosci/wakacje-w-morzu-plastiku-i-oceanie-toksyn</a>',
        },
        {
            text: '...nasze miasto stawia na ekoedukację?...',
            more:
                'W Jastrzębiu działa kampania informacyjno-edukacyjna na rzecz walki z niską emisją i poprawy jakości powietrza „Gmina z dobrą energią!”, której celem jest szerzenie wiedzy na temat niskiej emisji oraz metod walki z nią.',
        },
    ],
};
